import { NgModule } from '@angular/core';

import { CoreRoutes } from './core.routes';
import {
  AuthService,
  FormToolsService,
  HttpService,
  LocaleDataService,
  UploadService,
  WindowRefService
} from './services';

import {
  UpperCaseTextDirective,
  LowerCaseTextDirective,
  CurrentLocaleCodeDirective
} from './directives';

import { SlugPipe } from './pipes/slug.pipe';

@NgModule({
  imports: [
    CoreRoutes
  ],
  declarations: [
    UpperCaseTextDirective,
    LowerCaseTextDirective,
    CurrentLocaleCodeDirective,
    SlugPipe
  ],
  providers: [
    AuthService,
    FormToolsService,
    HttpService,
    LocaleDataService,
    UploadService,
    WindowRefService
  ],
  exports: [
    UpperCaseTextDirective,
    LowerCaseTextDirective,
    CurrentLocaleCodeDirective
  ]
})
export class CoreModule {}



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/core/core.module.ts